import request from '@/utils/request'

// 新增
export function addChargeStandard(obj) {
  return request({
    url: '/api/finance/conduct',
    method: 'post',
    data: obj
  })
}

// 修改
export function updateChargeStandard(obj) {
  return request({
    url: '/api/finance/conduct',
    method: 'put',
    data: obj
  })
}

// 详情
export function getChargeStandard(id) {
  return request({
    url: `/api/finance/conduct/${id}`,
    method: 'get'
  })
}

// 删除
export function delChargeStandard(id) {
  return request({
    url: `/api/finance/conduct/${id}`,
    method: 'delete'
  })
}

// 分页查询
export function getChargeStandardList(data) {
  return request({
    url: `/api/finance/conduct/page`,
    method: 'post',
    data: data
  })
}
